import { Brand } from '@blade/std-lib'

export const AvatarsHostTypeId = 'tradebot-tma/AvatarsHost'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AvatarsHostTypeId = typeof AvatarsHostTypeId

export type AvatarsHost = Brand.Branded<string, AvatarsHostTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvatarsHost = Brand.nominal<AvatarsHost>()
